import {Subscription,timer} from "rxjs";
import {HttpClient,HttpParams} from "@angular/common/http";
import {switchMap} from "rxjs/operators";
import {Progression} from "@domain/progression/progression";
import {Injector} from "@angular/core";
import {AbstractProgressHandler} from "./abstract-progress-handler";
import {PollingProgressHandlerConfig,pollingProgressHandlerDefaultConfig} from "./ProgressHandlerFactory";

/**
 * Handler de suivi de l'avancement d'un traitement back avec une connexion de type Polling
 *
 * @author Laurent Convert
 * @date 06/08/2025
 */
export class PollingProgressHandler extends AbstractProgressHandler {
	/** Configuration du handler */
	private readonly config: PollingProgressHandlerConfig;

	/** Souscription au polling http */
	private pollingSubscription?: Subscription;

	/** Client HTTP Angular */
	private httpClient: HttpClient;

	/**
	 * Constructeur
	 *
	 * @param config Options du handler
	 * @param injector Injecteur Angular
	 */
	constructor(config: PollingProgressHandlerConfig,injector: Injector) {
		super();

		//Initialisation
		this.config = Object.assign({},pollingProgressHandlerDefaultConfig,config);
		this.httpClient = injector.get(HttpClient);
	}

	/**
	 * Connexion au serveur et démarrage du suivi
	 */
	start(uuid: string): void {
		//Construction des paramètres HTTP
		const params: HttpParams = new HttpParams()
			.set('uuid',uuid)

		//Récupération de l'avancement à interval régulier (polling) et mise à jour de l'objet à partir du résultat
		this.pollingSubscription = timer(0,this.config.intervalMs).pipe(
			switchMap(() => this.httpClient.post<Progression>(this.config.url,null,{params: params}))
		).subscribe(status => this.update(status));
	}

	/**
	 * Arrêt du suivi et déconnexion du serveur
	 */
	stop(): void {
		//Désabonnement du timer, ce qui l'arrête
		this.pollingSubscription?.unsubscribe();
	}
}